import { render, staticRenderFns } from "./RadioBox.vue?vue&type=template&id=6c2e5d02&scoped=true"
import script from "./RadioBox.vue?vue&type=script&lang=js"
export * from "./RadioBox.vue?vue&type=script&lang=js"
import style0 from "./RadioBox.vue?vue&type=style&index=0&id=6c2e5d02&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e5d02",
  null
  
)

export default component.exports